module.exports = __webpack_public_path__ + "static/media/LR.7f661fb0.svg";